import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  email: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  avatar: PropTypes.string
});



// WEBPACK FOOTER //
// ./src/model/Types/user.js